<template>
  <div id="app">
    <bookman-navbar/>
    <router-view/>
    <bookman-footer v-if="isFooterShown"/>
    <fullpage-loader/>
    <start-ebook-modal/>
    <continue-reading-ebook-modal/>
    <sign-in-up-modal/>
  </div>
</template>
<script>
import BookmanFooter from '@/components/bookman-footer'
import BookmanNavbar from '@/components/bookman-navbar'
import continueReadingEbookModal from '@/components/ebooks-modals/continue-reading-ebook-modal'
import fullpageLoader from '@/components/fullpage-loader'
import startEbookModal from '@/components/ebooks-modals/start-ebook-modal'
import signInUpModal from '@/components/sign-in-up-modal'

export default {
  name: 'App',
  data () {
    return {
      isBurgerActive: false
    }
  },
  methods: {
    goToMainPage () {
      this.$router.push('/')
    },
    toggleBurgerActive () {
      this.isBurgerActive = !this.isBurgerActive
    }
  },
  computed: {
    getUserTicketsCount () {
      return this.$store.getters.getUserTicketsCount
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    isFooterShown () {
      return this.$store.getters.isFooterShown
    }
  },
  components: {
    BookmanFooter,
    BookmanNavbar,
    continueReadingEbookModal,
    fullpageLoader,
    startEbookModal,
    signInUpModal
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #19AAD1;
$primary-invert: findColorInvert($primary);
$secondary: #FFCC4C;
$secondary-invert: findColorInvert($secondary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "secondary": ($secondary, $secondary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
